<mat-form-field appearance="fill">
  <mat-label *ngIf="label">{{ label }} <span *ngIf="isRequired">*</span></mat-label>
  <mat-chip-grid #chipGrid>
    <mat-chip-row *ngFor="let value of values" [removable]="true" (removed)="remove(value)">
      {{ value }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input
      [placeholder]="placeholder"
      [formControl]="inputControl"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)"
      (blur)="onTouched()"
      (keypress)="onKeyPress($event)"
      type="text"
      inputmode="numeric"
      matInput
    />
  </mat-chip-grid>
  <mat-error *ngIf="ngControl?.control?.hasError('required') && ngControl?.control?.touched">
    This field is required
  </mat-error>
</mat-form-field>
